/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getFormValues, reduxForm, reset, submit } from 'redux-form';
import { useLocation } from 'react-router';
import { ModalWindow } from '../../../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { validate } from './utils';
import { FORM_NAME } from './constants';
import {
	getIsLoadingSelector,
	getIsCollectionGroupListLoadingSelector,
	getIsCollectionWayListLoadingSelector,
	getWaysOptionsSelector,
} from '../../selectors';
import { ChangeWayModalForm } from './change-way-modal-form';
import { removeModalQuery } from '../../../../utils/removeModalQuery';
import { groupToWayAction, orderGroupToWayAction, orderWayToWayAction, wayToWayAction } from './actions';
import { useInjectSaga } from '../../../../utils/injectSaga';
import saga from './saga';

const ChangeWayModalWrapper = ({
	onFormSubmit,
	onResetForm,
	formValues,
	onOrderGroupToWay,
	onOrderWayToWay,
	onGroupToWay,
	onWayToWay,
	isLoading,
	isOrdersGroupListLoading,
	isOrdersWayListLoading,
	waysOptions,
	isModalShown,
	setIsModalShown,
	collection,
	orders,
	group,
	way,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'orderGroupsChangeWayContainerSaga', saga });

	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const loading =
		isLoading ||
		Boolean(isOrdersGroupListLoading.find(el => el === group?.id)) ||
		Boolean(isOrdersGroupListLoading.find(el => el === formValues?.group_id)) ||
		Boolean(isOrdersWayListLoading.find(el => el === way?.id)) ||
		Boolean(isOrdersWayListLoading.find(el => el === formValues?.way_id));

	const handleModalCancel = () => {
		setIsModalShown(false);
		onResetForm(FORM_NAME);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);

		if (group) {
			if (orders?.length > 0 || collection?.length > 0) {
				onOrderGroupToWay({
					searchQuery: removeModalQuery(query.toString()),
					collection,
					orders,
					group,
					way_id: formValues?.way_id,
					callback: handleModalCancel,
				});
			} else {
				onGroupToWay({
					searchQuery: removeModalQuery(query.toString()),
					group,
					way_id: formValues?.way_id,
					callback: handleModalCancel,
				});
			}
		}

		if (way) {
			if (orders?.length > 0 || collection?.length > 0) {
				onOrderWayToWay({
					searchQuery: removeModalQuery(query.toString()),
					collection,
					orders,
					way,
					to_id: formValues?.way_id,
					callback: handleModalCancel,
				});
			} else {
				onWayToWay({
					searchQuery: removeModalQuery(query.toString()),
					way,
					to_id: formValues?.way_id,
					callback: handleModalCancel,
				});
			}
		}
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onClose={handleModalCancel}
			onKeyDown={handleKeyDown}
			headerText="Переместить в маршрут"
			style={{ width: '695px' }}
			actionButtons={[{ type: 'close', onClick: handleModalCancel, text: 'group_change' }]}
			modalContent={<ChangeWayModalForm waysOptions={waysOptions.filter(el => el.key !== way?.id)} />}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Переместить',
							color: 'success',
							disabled: loading,
							loading,
						},
						{
							onClick: handleModalCancel,
							text: 'Отмена',
							color: 'secondary',
							disabled: loading,
						},
					]}
				/>
			}
		/>
	);
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(ChangeWayModalWrapper);

const mapStateToProps = createStructuredSelector({
	formValues: state => getFormValues(FORM_NAME)(state),
	isLoading: getIsLoadingSelector(),
	isOrdersGroupListLoading: getIsCollectionGroupListLoadingSelector(),
	isOrdersWayListLoading: getIsCollectionWayListLoadingSelector(),
	waysOptions: getWaysOptionsSelector(),
});

const mapDispatchToProps = {
	onResetForm: reset,
	onFormSubmit: submit,
	onOrderGroupToWay: orderGroupToWayAction,
	onOrderWayToWay: orderWayToWayAction,
	onGroupToWay: groupToWayAction,
	onWayToWay: wayToWayAction,
};

export const ChangeWayModalComponent = connect(mapStateToProps, mapDispatchToProps)(withForm);

ChangeWayModalWrapper.propTypes = {
	onFormSubmit: PropTypes.func.isRequired,
	onResetForm: PropTypes.func.isRequired,
	formValues: PropTypes.object,
	onOrderGroupToWay: PropTypes.func.isRequired,
	onOrderWayToWay: PropTypes.func.isRequired,
	onGroupToWay: PropTypes.func.isRequired,
	onWayToWay: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
	isOrdersGroupListLoading: PropTypes.array.isRequired,
	isOrdersWayListLoading: PropTypes.array.isRequired,
	waysOptions: PropTypes.array,
	isModalShown: PropTypes.bool,
	setIsModalShown: PropTypes.func,
	collection: PropTypes.object,
	orders: PropTypes.object,
	group: PropTypes.object,
	way: PropTypes.object,
};
